
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, FormGroup, Label } from "reactstrap";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { C_DatePicker, C_Select } from "../../../CustomValidateForm";
import Order from "./Order";
import * as _act from "../../../store/actions";
import * as _cfunc from "../../../components/Common/CommonFunction";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList"

import { Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import * as report from '../../../Reports/ReportIndex'
import { url, mode, pageId } from "../../../routes/index"
import { order_Type } from "../../../components/Common/C-Varialbes";
import { IB_Order_Get_Api, Invoice_Send_CBM_to_CSS_update, Order_Send_CBM_to_CSS_update, order_Single_and_Multiple_Print_API, OrderPage_Edit_Post_API, OrderPage_Save_API_ForPO, OrderPage_Save_API_ForPO_Save } from "../../../helpers/backend_helper";
import { comAddPageFieldFunc, initialFiledFunc } from "../../../components/Common/validationFunction";
import { orderApprovalAction, postOrderConfirms_API, postOrderConfirms_API_Success } from "../../../store/actions";
import { orderApprovalMessage } from "./orderApproval";
import { priceListByCompay_Action, priceListByCompay_ActionSuccess } from "../../../store/Administrator/PriceList/action";
import OrderView from "./OrderView";
import OrderView_Modal from "./OrderView";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import { getOrdersMakeInvoiceDataAction, getOrdersMakeInvoiceDataActionSuccess } from "../../../store/Sales/bulkInvoice/action";
import { allLabelWithBlank } from "../../../components/Common/CommonErrorMsg/HarderCodeData";
import { sideBarPageFiltersInfoAction } from "../../../store/Utilites/PartyDrodown/action";
import { getCountryList_Action } from "../../../store/Administrator/CountryRedux/action";
import useCheckStockEntry from "../../../components/Common/commonComponent/CheckStockEntry";
import { orderCalculateFunc } from "./OrderPageCalulation";
import { getpartysetting_API, getpartysetting_API_Success } from "../../../store/Administrator/PartySetting/action";



const OrderList = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const [termsAndConTable, setTermsAndConTable] = useState([]);
    const IsFranchises = _cfunc.loginUserIsFranchisesRole()
    let originalStorageDetails = JSON.parse(localStorage.getItem(`${_cfunc.GET_COMPANY_FROM_URL()}_roleId`));


    const isSweetAndSnacksCompany = _cfunc.IsSweetAndSnacksCompany()
    const selectedOrderIdsRef = React.useRef(new Set());
    const LoginDetails = _cfunc.loginUserDetails();
    const isVisibleRateDrop = _cfunc.checkRateDropVisibility()

    const fileds = {
        FromDate: currentDate_ymd,
        ToDate: currentDate_ymd,
        Supplier: allLabelWithBlank,
        CustomerType: [allLabelWithBlank],
        CountryName: { value: LoginDetails?.Country_id, label: LoginDetails?.Country }
    }

    const initialSubPageMode = useMemo(() => {
        if (_cfunc.IsAuthorisedURL({ subPageMode: history.location.pathname, URL: url.ORDER_LIST_2 })) {
            return url.ORDER_LIST_2;
        }
        return history.location.pathname;
    }, []);

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const [subPageMode] = useState(initialSubPageMode);
    const [pageMode, setPageMode] = useState(mode.defaultList);
    const [extraSelect, setExtraSelect] = useState(false);


    const orderList4_or_app_orderList = (
        (subPageMode === url.ORDER_LIST_4) ||
        (subPageMode === url.APP_ORDER_LIST) ||
        (subPageMode === url.ORDER_APPROVAL)
    )

    const [otherState, setOtherState] = useState({
        masterPath: '',
        makeBtnShow: false,
        makeBtnShow: '',
        makeBtnName: '',
        IBType: '',
        showAprovalBtn: false
    });

    let reducers = useSelector(
        (state) => ({
            unhideMsg: state.GRNReducer.hideMsg,
            tableList: state.OrderReducer.orderList,
            GRNitem: state.GRNReducer.GRNitem,
            makeIBInvoice: state.InvoiceReducer.makeIBInvoice,
            deleteMsg: state.OrderReducer.deleteMsg,
            updateMsg: state.OrderReducer.updateMsg,
            postMsg: state.OrderReducer.postMsg,
            editData: state.OrderReducer.editData,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList,

            orderApprovalMsg: state.OrderReducer.orderApprovalMsg,
            Order_Close_Data: state.OrderReducer.Order_Close_Data,
            accountsApproveMsg: state.OrderReducer.accountsApproveMsg,
            accountsApproveLoading: state.OrderReducer.accountsApproveLoading,

            // approvalDetail: state.OrderReducer.approvalDetail,

            customerType: state.PriceListReducer.priceListByCompany,
            customerTypeDropLoading: state.PriceListReducer.listBtnLoading,

            orderConfirmMsg: state.OrderReducer.orderConfirmMsg,

            supplier: state.CommonAPI_Reducer.vendorSupplierCustomer,
            supplierDropLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,

            gobutton_Add_invoice: state.InvoiceReducer.gobutton_Add,
            goBtnloading: state.OrderReducer.goBtnLoading,

            countryList: state.CountryReducer.CountryList,
            countryListloading: state.CountryReducer.loading,

            printAllBtnLoading: state.PdfReportReducers.printAllBtnLoading,

            listBtnLoading: (state.OrderReducer.listBtnLoading
                || state.InvoiceReducer.listBtnLoading
                || state.PdfReportReducers.listBtnLoading
                || state.OrderReducer.orderConfirmLoading
                || state.InvoiceReducer.listBtnLoading
                || state.GRNReducer.listBtnLoading
                || state.PdfReportReducers.ReportBtnLoading),

        })
    );

    const gobtnId = `gobtn-${subPageMode}`
    const {
        pageField,
        GRNitem,
        supplier,
        makeIBInvoice,
        orderApprovalMsg,
        // approvalDetail,
        customerType,
        orderConfirmMsg,
        gobutton_Add_invoice,
        customerTypeDropLoading,
        supplierDropLoading,
        unhideMsg,
        userAccess,
        countryListloading,
        countryList,
        printAllBtnLoading,
        tableList,
        Order_Close_Data,
        accountsApproveMsg,
        accountsApproveLoading
    } = reducers;

    const ordersBulkInvoiceData = useSelector(state => state.BulkInvoiceReducer.ordersBulkInvoiceData);
    const makeBulkInvoiceLoading = useSelector(state => state.BulkInvoiceReducer.makeBulkInvoiceLoading);
    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);
    const [orderTypeSelect, setorderTypeSelect] = useState([]);
    const values = { ...state.values }
    const { fieldLabel } = state;
    const { Actionhandler } = useCheckStockEntry(commonPartyDropSelect);
    const tableAction = {
        getList: _act.getOrderListPage,
        deleteId: _act.deleteOrderId,
        postSucc: _act.saveOrderActionSuccess,
        updateSucc: _act.updateOrderIdSuccess,
        deleteSucc: _act.deleteOrderIdSuccess,
    }

    const lastFetchedPartyIdRef = React.useRef(null);
    // Common Party Dropdown useEffect
    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {
            dispatch(getpartysetting_API(_cfunc.loginSelectedPartyID(), _cfunc.loginCompanyID()));
            if (lastFetchedPartyIdRef.current !== commonPartyDropSelect.value) {
                lastFetchedPartyIdRef.current = commonPartyDropSelect.value;
                goButtonHandler("event", undefined);
            }
            dispatch(_act.GetVenderSupplierCustomer({ subPageMode, PartyID: commonPartyDropSelect.value }));

        } else {
            lastFetchedPartyIdRef.current = null;
            dispatch(_act.getOrderListPageSuccess([]));
            dispatch(_act.GetVenderSupplierCustomerSuccess([]));
            dispatch(getpartysetting_API(_cfunc.loginSelectedPartyID(), _cfunc.loginCompanyID()));   // ✅ real fetch, keeps sessionStorage + reducer consistent
            setState((i) => {
                let a = { ...i }
                a.values.CustomerType = [allLabelWithBlank]
                a.values.Supplier = allLabelWithBlank
                a.hasValid.CustomerType.valid = true;
                a.hasValid.Supplier.valid = true;
                return a
            })
        }

    }, [commonPartyDropSelect]);

    // sideBar Page Filters Information
    useEffect(() => {
        const filtersArray = [
            { label: fieldLabel.FromDate, content: _cfunc.date_dmy_func(values.FromDate) },
            { label: fieldLabel.ToDate, content: _cfunc.date_dmy_func(values.ToDate) },
            ...(orderList4_or_app_orderList
                ? [{ label: fieldLabel.CustomerType, content: values.CustomerType.map(obj => obj.label).join(',') }]
                : []),
            { label: fieldLabel.Supplier, content: values.Supplier.label }
        ];
        dispatch(sideBarPageFiltersInfoAction(filtersArray));
    }, [pageField, state, orderList4_or_app_orderList]);

    // Featch Modules List data First Rendering
    useEffect(() => {

        let page_Id = '';
        let page_Mode = mode.defaultList;
        let masterPath = '';
        let makeBtnShow = false;
        let IBType = '';
        let newBtnPath = '';
        let makeBtnName = '';
        let showAprovalBtn = false;

        if (subPageMode === url.ORDER_LIST_1) {
            page_Id = pageId.ORDER_LIST_1;
            masterPath = url.ORDER_1;
            newBtnPath = url.ORDER_1;
            page_Mode = mode.modeSTPList
            makeBtnShow = true;
            makeBtnName = "Make GRN"
        }
        else if (subPageMode === url.ORDER_LIST_2) {
            const IsAuthorisedURL = _cfunc.IsAuthorisedURL({ subPageMode: history.location.pathname, URL: url.ORDER_LIST_2 })
            if (IsAuthorisedURL) {
                page_Id = pageId.ORDER_LIST_2
                masterPath = url.POS_ORDER_IN_POS;
                newBtnPath = url.POS_ORDER_IN_POS;
                showAprovalBtn = true
            } else {
                page_Id = pageId.ORDER_LIST_2
                masterPath = url.ORDER_2;
                newBtnPath = url.ORDER_2;
                showAprovalBtn = true
                makeBtnName = "Make GRN"
            }
        }
        else if (subPageMode === url.IB_ORDER_PO_LIST) {
            page_Id = pageId.IB_ORDER_PO_LIST
            masterPath = url.IB_ORDER;
            newBtnPath = url.IB_ORDER;
            IBType = "IBPO"
        }
        else if (subPageMode === url.IB_ORDER_SO_LIST) {
            page_Id = pageId.IB_ORDER_SO_LIST
            masterPath = url.IB_SALES_ORDER;
            page_Mode = mode.modeSTPList
            newBtnPath = url.IB_SALES_ORDER;
            makeBtnShow = true;
            makeBtnName = "Make IB Invoice"
            IBType = "IBSO"
        }

        else if (subPageMode === url.ORDER_LIST_4) {
            page_Id = pageId.ORDER_LIST_4
            masterPath = url.ORDER_4;
            page_Mode = mode.modeSTPList
            newBtnPath = url.ORDER_4;
            makeBtnShow = true;
            makeBtnName = "Make Invoice"
            showAprovalBtn = true //Showing AprovalBtn in sales order list
        }

        else if (subPageMode === url.APP_ORDER_LIST) {
            page_Id = pageId.APP_ORDER_LIST
            // masterPath = url.ORDER_4;
            page_Mode = mode.modeSTPList
            // newBtnPath = url.ORDER_4;
            makeBtnShow = true;
            makeBtnName = "Make Invoice"
        }

        else if (subPageMode === url.IB_INVOICE_STP) {
            page_Id = pageId.IB_INVOICE_STP
            page_Mode = mode.modeSTPsave
            makeBtnShow = true;
            makeBtnName = "Make Invoice"
            IBType = "IBSO"
        }
        else if (subPageMode === url.GRN_STP_1) {
            page_Id = pageId.GRN_STP_1
            page_Mode = mode.modeSTPList
            makeBtnShow = true;
            makeBtnName = "Make GRN"
        }
        else if (subPageMode === url.GRN_STP_3) {
            page_Id = pageId.GRN_STP_3
            page_Mode = mode.modeSTPsave
            makeBtnShow = true;
            makeBtnName = "Make GRN"

        } else if (subPageMode === url.ORDER_QUATATION_LIST) {
            page_Id = pageId.ORDER_QUATATION_LIST
            masterPath = url.ORDER_QUATATION;
            newBtnPath = url.ORDER_QUATATION;
        }
        else if (subPageMode === url.ORDER_APPROVAL) {
            page_Id = pageId.ORDER_APPROVAL
            page_Mode = mode.modeSTPList
            showAprovalBtn = true
            // makeBtnShow/makeBtnName only if you also want a "Make ..." button on this page
        }




        setOtherState({ masterPath, makeBtnShow, newBtnPath, makeBtnName, IBType, showAprovalBtn })
        setPageMode(page_Mode)
        dispatch(_act.commonPageFieldListSuccess(null))

        dispatch(_act.commonPageFieldList(page_Id))
        dispatch(_act.BreadcrumbShowCountlabel(`${"Order Count"} :0`))
        if (!(_cfunc.loginSelectedPartyID() === 0)) {
            dispatch(_act.GetVenderSupplierCustomer({ subPageMode, PartyID: _cfunc.loginSelectedPartyID() }))
            if (lastFetchedPartyIdRef.current !== _cfunc.loginSelectedPartyID()) {
                lastFetchedPartyIdRef.current = _cfunc.loginSelectedPartyID();
                goButtonHandler("event", IBType);   // page load
            }
        }
        dispatch(priceListByCompay_Action());
        dispatch(getCountryList_Action());
        return () => {
            dispatch(_act.commonPageFieldListSuccess(null));
            dispatch(_act.getOrderListPageSuccess([]));//for clear privious order list 
            dispatch(_act.orderSinglegetSuccess({ Status: false }));
            dispatch(_act.GetVenderSupplierCustomerSuccess([]));
            dispatch(priceListByCompay_ActionSuccess([]));
            dispatch(_act.GoButtonForinvoiceAddSuccess({ Status: false }));
            localStorage.setItem(`${_cfunc.GET_COMPANY_FROM_URL()}_roleId`, JSON.stringify(originalStorageDetails));
        }
    }, []);




    useEffect(() => {
        if (subPageMode === url.GRN_STP_3) {
            dispatch(_act.BreadcrumbRadioButtonView(true));
        }
    }, [])

    useEffect(() => {
        if (pageField) {
            const fieldArr = pageField.PageFieldList
            comAddPageFieldFunc({ state, setState, fieldArr })
        }
    }, [pageField])

    useEffect(() => {

        if (GRNitem.Status === true && GRNitem.StatusCode === 200) {

            history.push({
                pathname: GRNitem.path,
                page_Mode: GRNitem.pageMode,
            })
        }
    }, [GRNitem])

    useEffect(() => {

        if (makeIBInvoice.Status === true && makeIBInvoice.StatusCode === 200) {
            history.push({
                pathname: makeIBInvoice.path,
                page_Mode: makeIBInvoice.page_Mode,
            })
        }
    }, [makeIBInvoice]);

    useEffect(() => {
        if (gobutton_Add_invoice.Status === true && gobutton_Add_invoice.StatusCode === 200) {

            history.push({
                pathname: gobutton_Add_invoice.path,
            })
        }
    }, [gobutton_Add_invoice]);

    useEffect(() => {
        if (ordersBulkInvoiceData.Status === true && ordersBulkInvoiceData.StatusCode === 200) {

            dispatch(getOrdersMakeInvoiceDataActionSuccess({ ...ordersBulkInvoiceData, Status: false }));
            history.push({
                pathname: url.BULK_INVOICE,
            })
        }
        else if (ordersBulkInvoiceData.Status === true && ordersBulkInvoiceData.StatusCode === 204) {
            customAlert({
                Type: 3,
                Message: ordersBulkInvoiceData.Message,
            })
            dispatch(getOrdersMakeInvoiceDataActionSuccess({ Status: false }));
            return
        }
    }, [ordersBulkInvoiceData]);

    useEffect(() => {
        const Todate = _cfunc.ToDate({ FromDate: values.FromDate, Todate: values.ToDate })
        setState((i) => {
            const a = { ...i }
            a.values.ToDate = Todate;
            a.hasValid.ToDate.valid = true
            return a
        })

    }, [values.FromDate]);


    useEffect(() => {
        if (Order_Close_Data.Status === true && Order_Close_Data.StatusCode === 200) {
            dispatch(_act.ManuallyOrderCloseSuccess({ Status: false }))

            const isSilentRAClose = sessionStorage.getItem('silentOrderCloseForRA') === 'true';
            sessionStorage.removeItem('silentOrderCloseForRA');
            if (isSilentRAClose) return; // RA forced-close from Challan page — no alert/refresh

            goButtonHandler("event",)
            customAlert({
                Type: 1,
                Message: Order_Close_Data.Message,
            })

        } else if (Order_Close_Data.Status === true) {
            dispatch(_act.ManuallyOrderCloseSuccess({ Status: false }))

            const isSilentRAClose = sessionStorage.getItem('silentOrderCloseForRA') === 'true';
            sessionStorage.removeItem('silentOrderCloseForRA');
            if (isSilentRAClose) return; // suppress failure alert too — keep it fully quiet

            customAlert({
                Type: 2,
                Message: JSON.stringify(Order_Close_Data.Message),
            })
        }
    }, [Order_Close_Data]);

    useEffect(() => {
        if (accountsApproveMsg.Status === true && accountsApproveMsg.StatusCode === 200) {
            dispatch(_act.orderAccountingApprovalActionSuccess({ Status: false }))
            customAlert({
                Type: 1,
                Message: accountsApproveMsg.Message,
            }).then(() => {
                goButtonHandler("event")   // refetch only after user clicks OK
            })
        } else if (accountsApproveMsg.Status === true) {
            dispatch(_act.orderAccountingApprovalActionSuccess({ Status: false }))
            customAlert({
                Type: 2,
                Message: JSON.stringify(accountsApproveMsg.Message),
            })
        }
    }, [accountsApproveMsg]);

    //order confirm
    useEffect(() => {

        if (orderConfirmMsg.Status === true && orderConfirmMsg.StatusCode === 200 && !(orderConfirmMsg.conform_saveInvoice)) {
            dispatch(postOrderConfirms_API_Success({ Status: false }))
            goButtonHandler("event",)
            customAlert({
                Type: 1,
                Message: orderConfirmMsg.Message,
            })


        } else if (orderApprovalMsg.Status === true) {
            dispatch(postOrderConfirms_API_Success({ Status: false }))
            customAlert({
                Type: 2,
                Message: JSON.stringify(orderConfirmMsg.Message),
            })
        }
    }, [orderConfirmMsg]);

    useEffect(() => {

        orderApprovalMessage({ dispatch, orderApprovalMsg, goButtonHandler })

    }, [orderApprovalMsg]);

    // useEffect(() => {
    // orderApprovalFunc({ dispatch, approvalDetail })
    // }, [approvalDetail]);

    useEffect(() => {
        if (unhideMsg.Status === true && unhideMsg.StatusCode === 200) {
            dispatch(_act.hideInvoiceForGRFActionSuccess({ Status: false }));
            goButtonHandler("event")
            customAlert({
                Type: 1,
                Message: unhideMsg.Message,
            })
        } else if (unhideMsg.Status === true) {
            dispatch(_act.hideInvoiceForGRFActionSuccess({ Status: false }));
            customAlert({
                Type: 2,
                Message: JSON.stringify(unhideMsg.Message),
            })
        }

    }, [unhideMsg]);

    const supplierOptions = supplier.map((i) => ({
        value: i.id,
        label: i.Name,
    }));

    supplierOptions.unshift({
        value: "",
        label: " All"
    });

    const customerTypeOptions = customerType.map((index) => ({
        value: index.id,
        label: index.Name,
    }));

    const CountryListOptions = countryList?.map((data) => ({
        value: data.id,
        label: data.Country,
        CurrencySymbol: data.CurrencySymbol
    }));

    function oderAprovalBtnFunc({ editId, btnId }) {

        // _cfunc.btnIsDissablefunc({ btnId, state: false })
        let config = {}
        config.btnId = btnId;
        config.orderId = editId;
        // dispatch(getOrderApprovalDetailAction(config))
        dispatch(orderApprovalAction({ jsonBody: JSON.stringify({ Order: editId }), btnId }))
    }

    const makeBtnFunc = (list = [], btnId) => {
        const obj = list[0];

        const customer = {
            value: obj.CustomerID,
            label: obj.Customer,
            GSTIN: obj.CustomerGSTIN,
            IsTCSParty: obj.IsTCSParty,
            ISCustomerPAN: obj.CustomerPAN,
            AdvanceAmount: obj.AdvanceAmount,
            OrderID: obj.id
        };

        const jsonBody = JSON.stringify({
            FromDate: obj.OrderDate,
            Customer: obj.CustomerID,
            Party: _cfunc.loginSelectedPartyID(),
            OrderIDs: obj.id.toString(),
            IsRateWise: isVisibleRateDrop ? 2 : 1
        });

        Actionhandler({
            transactionDate: _cfunc.date_ymd_func(),  // ✅ row's date
            callback: () => {

                if (subPageMode === url.IB_INVOICE_STP) {
                    dispatch(_act.makeIB_InvoiceAction({
                        jsonBody,
                        path: url.IB_INVOICE,
                        pageMode: mode.defaultsave,
                        customer,
                        btnId
                    }));
                }
                else if (orderList4_or_app_orderList) {
                    dispatch(_act.GoButtonForinvoiceAdd({
                        jsonBody,
                        btnId,
                        customer,
                        subPageMode: _cfunc.loginUserIsFranchisesRole() ? url.FRANCHAISE_INVOICE : url.INVOICE_1,
                        path: _cfunc.loginUserIsFranchisesRole() ? url.FRANCHAISE_INVOICE : url.INVOICE_1,
                        pageMode: mode.defaultsave,
                    }));
                }
                else {
                    var isGRNSelect = '';
                    const grnRef = [];

                    if (list.length > 0) {
                        list.forEach(ele => {
                            if (ele.hasSelect) {
                                grnRef.push({
                                    Invoice: (ele.OrderType === 3) ? ele.id : null,
                                    Order: (ele.OrderType === 1) ? ele.id : null,
                                    Full_OrderNumber: ele.FullOrderNumber,
                                    Inward: url.GRN_STP_3 ? true : false,
                                    Challan: ele.POType === "Challan" ? ele.id : '',
                                    POType: ele.POType,
                                    OrderDate: ele.OrderDate,
                                    CustomerID: ele.CustomerID,
                                    CustomerName: ele.Customer,
                                    GRN_From: subPageMode
                                });
                                isGRNSelect = isGRNSelect.concat(`${ele.id},`);
                            }
                        });

                        if (isGRNSelect) {
                            let path = (subPageMode === url.GRN_STP_3 ? url.GRN_ADD_3 : url.GRN_ADD_1);
                            isGRNSelect = isGRNSelect.replace(/,*$/, '');
                            let isMode = 1;

                            if (list[0].POType === "Challan") isMode = 2;

                            if (subPageMode === url.GRN_STP_3) {
                                isMode = isSweetAndSnacksCompany ? 1 : 3;
                                path = isSweetAndSnacksCompany ? url.GRN_ADD_1 : url.GRN_ADD_3;
                            } else if (subPageMode === url.IB_ORDER_SO_LIST) {
                                path = url.IB_INVOICE;
                            }

                            const jsonBody = JSON.stringify({
                                OrderIDs: isGRNSelect,
                                Mode: subPageMode === url.IB_ORDER_SO_LIST ? undefined : isMode,
                                DemandDate: subPageMode === url.IB_ORDER_SO_LIST ? list[0].OrderDate : undefined,
                                Party: subPageMode === url.IB_ORDER_SO_LIST ? _cfunc.loginPartyID() : undefined
                            });

                            dispatch(_act.makeGRN_Mode_1Action({
                                jsonBody,
                                subPageMode,
                                pageMode,
                                path,
                                grnRef,
                                InvoiceDate: obj.dashboardOrderDate,
                                btnId: `btn-makeBtn-${obj.id}`
                            }));

                        } else {
                            alert("Please Select Order1");
                        }
                    }
                }
            }
        });
    };

    function editBodyfunc(config) {

        const { rowData } = config;
        try {
            const jsonBody = JSON.stringify({
                Party: rowData.SupplierID,
                Customer: rowData.CustomerID,
                EffectiveDate: rowData.OrderDate,
                OrderID: (subPageMode === url.IB_ORDER_PO_LIST) ? 0 : rowData.id,
                Demand: (subPageMode === url.IB_ORDER_PO_LIST) ? rowData.id : 0,
                RateParty: rowData.CustomerID,
                OrderType: ((subPageMode === url.ORDER_LIST_4) || (subPageMode === url.APP_ORDER_LIST)) ? order_Type.SaleOrder : order_Type.PurchaseOrder
            })

            dispatch(_act.editOrderId({ jsonBody, ...config, subPageMode }));
        } catch (error) { }
    }

    function downBtnFunc(config) {

        let id = config.rowData.id
        if (_cfunc.isRACompany()) {
            config["ReportType"] = report.RAOrder;
        } else {
            config["ReportType"] = report.order1;
        }

        if (subPageMode === url.IB_ORDER_PO_LIST || subPageMode === url.IB_ORDER_SO_LIST) {
            dispatch(_act.getpdfReportdata(IB_Order_Get_Api, config))
        } else {
            config['jsonBody'] = {
                "OrderIDs": id.toString(),
                "PartyId": _cfunc.loginSelectedPartyID()
            }

            dispatch(_act.getpdfReportdata(order_Single_and_Multiple_Print_API, config))
        }

    }

    function thermalprintBtnFunc(config) {
        let id = config.rowData.id
        const reportType = report.orderThermalPrintReport
        config["ReportType"] = reportType;
        config['jsonBody'] = {
            "OrderIDs": id.toString(),
            "PartyId": _cfunc.loginSelectedPartyID()
        }
        dispatch(_act.getpdfReportdata(order_Single_and_Multiple_Print_API, config))
    }


    function minPrintBtn_Func(config) {
        let id = config.rowData.id
        let reportType = ""
        if (subPageMode === url.ORDER_LIST_4) {
            reportType = report.FrenchiesesOrder
        } else {
            reportType = report.FrenchiesesOrder
        }
        config["ReportType"] = reportType;
        config['jsonBody'] = {
            "OrderIDs": id.toString(),
            "PartyId": _cfunc.loginSelectedPartyID()
        }
        dispatch(_act.getpdfReportdata(order_Single_and_Multiple_Print_API, config))
    }

    const AccountsApprove_Handler = (row = []) => {
        let ischeck = row.filter(i => (i.selectCheck && !i.forceSelectDissabled));
        if (!ischeck.length > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.selectOneOrder,
            });
            return;
        }
        let orderIdArray = ischeck.map(obj => obj.id);
        let jsonBody = JSON.stringify({ OrderID: orderIdArray, IsAccountingApproved: true });
        dispatch(_act.orderAccountingApprovalAction({ jsonBody, btnId: gobtnId }));
    };
    async function hideBtnFunc(rowdata) {
        const isHideValue = rowdata[0].isHideValue
        const RowInvoiceId = rowdata[0].id

        let jsonBody = JSON.stringify({ InvoiceID: RowInvoiceId, Mode: isHideValue, Comment: "" })
        const isConfirmed = await customAlert({
            Type: 7,
            Message: alertMessages.unHideInvoiceOrNot,
        });

        if (isConfirmed) {
            dispatch(_act.hideInvoiceForGRFAction({ jsonBody }))
        }
    }

    function viewApprovalBtnFunc(config) {
        let id = config.rowData.id

        config['jsonBody'] = {
            "OrderIDs": id.toString(),
            "PartyId": _cfunc.loginSelectedPartyID()
        }
        dispatch(_act.viewOrderSingleget(config))
    }

    function goButtonHandler(event, IBType) {
        // Purchase Order, Sales Order, Order List 1: always send the flag
        const sendFutureDateFlag = isSweetAndSnacksCompany && [url.ORDER_LIST_1, url.ORDER_LIST_2, url.ORDER_LIST_4].includes(subPageMode);
        _cfunc.btnIsDissablefunc({ btnId: gobtnId, state: true })
        try {
            if ((_cfunc.loginSelectedPartyID() === 0)) {
                customAlert({ Type: 3, Message: alertMessages.commonPartySelectionIsRequired });
                return;
            };
            let filtersBody = {}
            const isCustomerType = values.CustomerType.filter(i => !(i.value === '')).map(obj => obj.value).join(',');

            const PO_filters = {
                "FromDate": values.FromDate,
                "ToDate": values.ToDate,
                "Supplier": values.Supplier.value,
                "Customer": _cfunc.loginSelectedPartyID(),
                "OrderType": order_Type.PurchaseOrder,
                "CustomerType": "",
                "IBType": IBType ? IBType : otherState.IBType,
                "DashBoardMode": 0,
                "Country": values.CountryName.value,
                "IsFutureDateOrder": sendFutureDateFlag

            }
            const SO_filters = {
                "FromDate": values.FromDate,
                "ToDate": values.ToDate,
                "Supplier": _cfunc.loginSelectedPartyID(),//Suppiler swipe
                "Customer": values.Supplier.value,//customer swipe
                "OrderType": order_Type.SaleOrder,
                "CustomerType": isCustomerType,
                "IBType": IBType ? IBType : otherState.IBType,
                "DashBoardMode": 0,
                "Country": values.CountryName.value,
                "IsFutureDateOrder": sendFutureDateFlag

            }
            const GRN_STP_3_filters = {
                "FromDate": values.FromDate,
                "ToDate": values.ToDate,
                "Supplier": values.Supplier.value,
                "Customer": _cfunc.loginSelectedPartyID(),
                "OrderType": isSweetAndSnacksCompany ? order_Type.PurchaseOrder : order_Type.InvoiceToGRN,
                "CustomerType": '',
                "IBType": IBType ? IBType : otherState.IBType,
                "DashBoardMode": 0,
                "Country": values.CountryName.value,
                "IsFutureDateOrder": sendFutureDateFlag

            }

            if (orderList4_or_app_orderList || subPageMode === url.IB_ORDER_SO_LIST) {
                filtersBody = JSON.stringify(SO_filters);
            }
            else if (subPageMode === url.GRN_STP_3) {
                filtersBody = JSON.stringify(GRN_STP_3_filters);
            }
            else {
                filtersBody = JSON.stringify(PO_filters);
            }

            dispatch(_act.getOrderListPage({ subPageMode, filtersBody, btnId: gobtnId, userAccess }))

        } catch (error) { _cfunc.btnIsDissablefunc({ btnId: gobtnId, state: false }) }
    }

    function fromdateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.FromDate = date;
            a.hasValid.FromDate.valid = true
            return a
        })
    }

    function todateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.ToDate = date;
            a.hasValid.ToDate.valid = true
            return a
        })
    }

    function supplierOnchange(e) {
        setState((i) => {
            const a = { ...i }
            a.values.Supplier = e;
            a.hasValid.Supplier.valid = true
            return a
        })
    }

    function CountryOnchange(e) {

        let StorageDetails = JSON.parse(localStorage.getItem(`${_cfunc.GET_COMPANY_FROM_URL()}_roleId`));

        StorageDetails.Country = e.label; // Updating age
        StorageDetails.Country_id = e.value;
        StorageDetails.CurrencySymbol = e.CurrencySymbol;
        StorageDetails.Weight = e.Weight;
        localStorage.setItem(`${_cfunc.GET_COMPANY_FROM_URL()}_roleId`, JSON.stringify(StorageDetails));
        setState((i) => {
            const a = { ...i }
            a.values.CountryName = e;
            a.hasValid.CountryName.valid = true
            return a
        })

        const elements = document.querySelectorAll('.CurrencySymbol-Class');
        elements.forEach((element) => {
            element.innerHTML = e.CurrencySymbol;
        });
        dispatch(_act.getOrderListPageSuccess([]));//for clear privious order list 

    }
    function customerTypeOnchange(e = []) {

        if (e.length === 0) {
            e = [allLabelWithBlank]
        } else {
            e = e.filter(i => !(i.value === ''))
        }
        setState((i) => {
            const a = { ...i }
            a.values.CustomerType = e;
            a.hasValid.CustomerType.valid = true
            return a
        })
    }

    const OrderConfirm_Handler = (row = []) => {


        let ischeck = row.filter(i => (i.selectCheck && !i.forceSelectDissabled))
        if (!ischeck.length > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.selectOneOrder,
            });
            return
        }
        let idString = ischeck.map(obj => obj.id).join(',')
        let jsonBody = { OrderIDs: idString }
        dispatch(postOrderConfirms_API({ jsonBody }))
    }

    const BulkInvoice_Handler = (allList = []) => {

        // let checkRows = allList.filter(i => ((i.selectCheck || i.ExtraSelect) && (!i.forceSelectDissabled) || (!i.forceExtraSelectDissabled)))

        let checkRows = allList.filter(i => {
            return (((i.selectCheck || i.ExtraSelect)) && ((!i.forceSelectDissabled) || (!i.forceExtraSelectDissabled)));
        });

        if (((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany))) {
            const isSameCustumer = checkRows.every(item => item.CustomerID === checkRows[0].CustomerID);
            if (!isSameCustumer) {
                customAlert({
                    Type: 3,
                    Message: alertMessages.selectSameCustomer,
                });
                return
            }
        }

        if (!checkRows.length > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.selectOneOrder,
            });
            return
        }
        let idString = checkRows.map(row => row.id).join(',')
        let jsonBody = {
            OrderIDs: idString,
            "Customer": null,
            "Party": _cfunc.loginSelectedPartyID(),
            IsRateWise: isVisibleRateDrop ? 2 : 1
        }


        dispatch(getOrdersMakeInvoiceDataAction({ jsonBody, subPageMode: subPageMode, path: url.INVOICE_1 }));
    }

    const pageFieldMaster = reducers?.pageField?.PageFieldMaster;

    if (Array.isArray(pageFieldMaster) && !(IsFranchises)) {

        for (let i = pageFieldMaster.length - 1; i >= 0; i--) {
            if (pageFieldMaster[i].ControlID === "AdvanceAmount") {
                pageFieldMaster.splice(i, 1);
            }
        }
    }


    const HeaderContent = () => {
        return (
            <div className="px-2   c_card_filter text-black" >
                <div className="row" >
                    <Col lg={(orderList4_or_app_orderList) ? 2 : 3} className="">
                        <FormGroup className="mb- row mt-3 " >
                            <Label className="col-sm-5 p-2"
                                style={{ width: "83px" }}> {!(fieldLabel.FromDate === '') ? fieldLabel.FromDate : "FromDate"}</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    options={{
                                        altInput: true,
                                        altFormat: "d-m-Y",
                                        dateFormat: "Y-m-d",
                                    }}
                                    name='FromDate'
                                    value={values.FromDate}
                                    onChange={fromdateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col lg={(orderList4_or_app_orderList) ? 2 : 3} className="">
                        <FormGroup className="mb- row mt-3 " >
                            <Label className="col-sm-5 p-2"
                                style={{ width: "65px" }}> {!(fieldLabel.ToDate === '') ? fieldLabel.ToDate : "ToDate"}</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    options={{
                                        minDate: (_cfunc.disablePriviousTodate({ fromDate: values.FromDate })),
                                        altInput: true,
                                        altFormat: "d-m-Y",
                                        dateFormat: "Y-m-d",
                                    }}
                                    name="ToDate"
                                    value={_cfunc.ToDate({ FromDate: values.FromDate, Todate: values.ToDate })}
                                    onChange={todateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>


                    {(orderList4_or_app_orderList) &&
                        <Col lg={3}>
                            <FormGroup className="mb-1 row mt-3 " >
                                <Label className="col-sm p-2"
                                >
                                    {!(fieldLabel.CustomerType === '') ? fieldLabel.CustomerType : "Customer Type"}
                                </Label>
                                <Col sm="8">
                                    <C_Select
                                        name="CustomerType"
                                        classNamePrefix="select2-Customer"
                                        value={values.CustomerType}
                                        options={customerTypeOptions}
                                        onChange={customerTypeOnchange}
                                        isMulti={true}
                                        isLoading={customerTypeDropLoading}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                    />
                                </Col>
                            </FormGroup>

                        </Col >}

                    <Col lg={(orderList4_or_app_orderList) ? 4 : 5}>
                        <FormGroup className="mb-2 row mt-3 " >
                            <Label className="col-md-4 p-2"

                                style={{ width: "115px" }}>{(!(fieldLabel.Supplier === '')) ? fieldLabel.Supplier : (orderList4_or_app_orderList ? "Customer" : "Supplier")}</Label>
                            <Col sm="8">

                                <C_Select
                                    name="Supplier"
                                    classNamePrefix="select2-Customer"
                                    value={values.Supplier}
                                    options={supplierOptions}
                                    onChange={supplierOnchange}
                                    isLoading={supplierDropLoading}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                />
                            </Col>


                        </FormGroup>
                    </Col >


                    <Col sm="1" className="mt-3 ">
                        <Go_Button loading={reducers.goBtnloading} id={gobtnId} onClick={goButtonHandler} />
                    </Col>
                </div>
                <div>
                    {
                        (subPageMode === url.ORDER_LIST_4 && LoginDetails?.PartyType === "Division") &&

                        <Col lg={2} className="">
                            <FormGroup className="mb- row mt-3 " >
                                <Label className="col-sm-5 p-2"
                                    style={{ width: "83px" }}> {(!(fieldLabel.CountryName === '')) ? fieldLabel.CountryName : "Country"}</Label>
                                <Col sm="7">
                                    <C_Select
                                        name="CountryName"
                                        classNamePrefix="select2-Customer"
                                        value={values.CountryName}
                                        options={CountryListOptions}
                                        onChange={CountryOnchange}
                                        isLoading={countryListloading}
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>


                    }
                </div>
            </div >
        )
    }

    const ExtraSelectBtnHandler = (row = []) => {

        let config = {};
        let ischeck = row.filter(i => (i.ExtraSelect))
        if (!ischeck.length > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.selectOneOrder,
            });
            return
        }
        let idString = ischeck.map(obj => obj.id).join(',')
        config["ReportType"] = report.FrenchiesesOrder;
        config['jsonBody'] = { OrderIDs: idString, PartyId: _cfunc.loginSelectedPartyID() }
        dispatch(_act.getpdfReportdata(order_Single_and_Multiple_Print_API, config))

    };


    async function sendFunc(config) {
        const { rowData } = config;

        try {
            dispatch(_act.sendActionLoad({ btnId: config.btnId }))
            // 1️⃣ Call the Edit API first
            const editResp = await OrderPage_Edit_Post_API({
                jsonBody:
                    ({
                        Party: rowData.SupplierID,
                        Customer: rowData.CustomerID,
                        EffectiveDate: rowData.OrderDate,
                        OrderID: (subPageMode === url.IB_ORDER_PO_LIST) ? 0 : rowData.id,
                        Demand: (subPageMode === url.IB_ORDER_PO_LIST) ? rowData.id : 0,
                        RateParty: rowData.CustomerID,
                        OrderType: ((subPageMode === url.ORDER_4) || (subPageMode === url.APP_ORDER_LIST))
                            ? order_Type.SaleOrder
                            : order_Type.PurchaseOrder,
                    })
            });
            // 2️⃣ Filter items with Quantity > 0
            const filteredItems = (editResp?.Data?.OrderItems || []).filter(item => {
                const qty = Number(item.Quantity);
                return !isNaN(qty) && qty > 0;
            });

            if (filteredItems.length === 0) {
                console.warn("No valid items with Quantity > 0 to send.");
                return;
            }

            // 3️⃣ Prepare OrderItem array
            const orderItems = filteredItems.map(item => {

                return {
                    Item: item.Item_id,
                    ItemName: item.ItemName,
                    Quantity: Number(item.Quantity), // ✅ convert to number
                    MRP: _cfunc.loginUserIsFranchisesRole() ? null : item.MRP_id,
                    MRPValue: _cfunc.loginCompanyID() === 4 ? "1" : item.MRPValue,
                    Rate: item.Rate,
                    Unit: item.Unit_id,
                    BaseUnitQantityofNoUnit: item.BaseUnitQuantityNoUnit ?? "1.000", // ✅ ensure default
                    BaseUnitQuantity: Number(item.BaseUnitQuantity).toFixed(2), // ✅ should match expected "12.00"
                    Margin: "",
                    BaseUnitID_id: item.BaseUnitID_id,
                    GST: item.GST_id,
                    SAPItemCode: item.SAPItemCode,
                    CGST: item.CGST,
                    SGST: item.SGST,
                    IGST: item.IGST,
                    GSTPercentage: item.GSTPercentage,
                    CGSTPercentage: item.CGSTPercentage,
                    SGSTPercentage: item.SGSTPercentage,
                    IGSTPercentage: item.IGSTPercentage,
                    BasicAmount: item.BasicAmount,
                    GSTAmount: item.GSTAmount,
                    Amount: item.Amount,
                    TaxType: 'GST',
                    DiscountType: Number(item.DiscountType), // ✅ ensure number
                    Discount: Number(item.Discount),
                    DiscountAmount: Number(item.DiscountAmount).toFixed(2),
                    IsDeleted: 0,
                    Comment: item.Comment,
                    OrderItem: item.IsHighlightItemInPrint,
                    MOQQuantity: Number(item.SuggestedMOQQuantity),
                };
            });




            const division = commonPartyDropSelect.value;
            const termsAndConditions = (termsAndConTable?.length > 0)
                ? termsAndConTable.map(() => ({
                    TermsAndCondition: 1,
                    IsDeleted: 0
                }))
                : [{ TermsAndCondition: 1, IsDeleted: 0 }];

            const jsonBody = JSON.stringify({
                OrderDate: rowData.OrderDate,
                DeliveryDate: _cfunc.date_ymd_func(rowData.DeliveryDate),
                OrderAmount: Number((rowData.OrderAmount || "0").replace(/,/g, '')),
                OrderItem: orderItems,
                Description: "",
                BillingAddress: editResp.Data.BillingAddressID, // ✅ prefer ID
                ShippingAddress: editResp.Data.ShippingAddressID, // ✅ prefer ID
                OrderNo: 1,
                FullOrderNumber: "PO0001",
                DemandNo: 1,
                FullDemandNumber: "PO0001",
                Division: division,
                POType: 1, // HardCoded poType for all
                POFromDate: rowData.OrderDate,
                POToDate: rowData.OrderDate,
                CreatedBy: _cfunc.loginUserID(),
                UpdatedBy: _cfunc.loginUserID(),
                OrderTermsAndConditions: termsAndConditions,
                Customer: rowData.CustomerID,
                Supplier: rowData.SupplierID,
                OrderType: rowData.OrderType,
                IsConfirm: true,
                AdvanceAmount: 0,
                Send_CBM_to_CSS: (rowData.CBM_To_CSS_Mapping || rowData.Send_CBM_to_CSS),
                CustomerSAPCode: rowData.CustomerSAPCode,
                SupplierSAPCode: rowData.SupplierSAPCode,
                PaymentMode1: editResp.Data.PaymentMode1,
                PaymentMode1Amount: editResp.Data.PaymentMode1Amount,
                PaymentMode2: editResp.Data.PaymentMode2,
                PaymentMode2Amount: editResp.Data.PaymentMode2Amount,
            });

            // 5️⃣ Save API
            const resp = await OrderPage_Save_API_ForPO_Save({ jsonBody, subPageMode });
            // if (resp?.blocked) return;
            if (resp?.StatusCode === 200 && resp?.Status === true) {
                await Order_Send_CBM_to_CSS_update({
                    jsonBody: JSON.stringify({
                        Send_CBM_to_CSS: true,
                        OrderID: rowData.id
                    }),
                });
                customAlert({
                    Type: 1,
                    Message: resp.Message
                });
                goButtonHandler();
            } else {
                customAlert({
                    Type: 4,
                    Message: resp?.Message
                });
            }
        } catch (error) {
            if (error === "Blocked") return;
            customAlert({
                Type: 4,
                Message: error?.Message
            });
        } finally {
            dispatch(_act.sendActionLoadStop()); // stop loader
        }
    }

    const makeChallan = ({ rowData, btnId }) => {

        const customer = {
            value: rowData.CustomerID,
            label: rowData.Customer,
            GSTIN: rowData.CustomerGSTIN,
            IsTCSParty: rowData.IsTCSParty,
            ISCustomerPAN: rowData.CustomerPAN,
            AdvanceAmount: rowData.AdvanceAmount,
            OrderID: rowData.id
        };

        const jsonBody = JSON.stringify({
            FromDate: rowData.OrderDate,
            Customer: rowData.CustomerID,
            Party: _cfunc.loginSelectedPartyID(),
            OrderIDs: rowData.id.toString(),
            IsRateWise: isVisibleRateDrop ? 2 : 1
        });

        // RA-only: this order needs a force-close once its Challan is saved
        if (_cfunc.isRACompany() && rowData.ISAdvancePaymentParty === false) {
            sessionStorage.setItem('forceCloseOrderOnChallan', rowData.id.toString());
        } else {
            sessionStorage.removeItem('forceCloseOrderOnChallan');
        }

        Actionhandler({
            transactionDate: _cfunc.date_ymd_func(),  // ✅ row's date
            callback: () => {
                dispatch(_act.GoButtonForinvoiceAdd({
                    jsonBody,
                    btnId,
                    customer,
                    subPageMode: url.CHALLAN_MASTER,
                    path: url.CHALLAN_MASTER,
                    pageMode: mode.defaultsave,
                }));
            }
        });
    };



    const ManuallyCloseFunc = async ({ rowData, btnId }) => {
        if (subPageMode === url.ORDER_APPROVAL) {
            let alertRepsponse = await customAlert({
                Type: 8,
                Message: "Are you sure you want to approve this order ?"
            });
            if (alertRepsponse) {
                const jsonBody = JSON.stringify({
                    OrderID: rowData.id.toString(),
                    IsAccountingApproved: true
                });
                dispatch(_act.orderAccountingApprovalAction({ jsonBody, btnId }));
            }
        } else {
            if (!(subPageMode === url.ORDER_LIST_1)) {

                if (rowData.ChallanCount === 0) {
                    customAlert({
                        Type: 4,
                        Message: "Only partially fulfilled orders can be manually closed."
                    });
                    return;
                }
            }

            let alertRepsponse = await customAlert({
                Type: 8,
                Message: "Are you sure you want to close this order manually ?"
            })
            if (alertRepsponse) {
                const jsonBody = JSON.stringify({
                    OrderID: rowData.id,
                    IsOrderClose: true
                });
                dispatch(_act.ManuallyOrderClose({ jsonBody, btnId }));
            }
        }
    };





    const headerselecthandler = ({ event, tableList }) => {

        const isChecked = event.currentTarget.checked
        let updatedTableList = []

        if (subPageMode === url.ORDER_LIST_4 && isSweetAndSnacksCompany) {
            updatedTableList = tableList.map(row => ({

                ...row,
                ExtraSelect: row.InvoiceCreated ? false : isChecked
            }));
        } else {
            updatedTableList = tableList.map(row => ({
                ...row,
                ExtraSelect: isChecked
            }));
        }



        dispatch(_act.getOrderListPageSuccess(updatedTableList))
    }

    const selecthandler = ({ event, rowData, tableList }) => {
        const isChecked = event.currentTarget.checked;
        const partyId = rowData.CustomerID;
        const isCssBulkInvoice = subPageMode === url.ORDER_LIST_4 && isSweetAndSnacksCompany;

        if (!isCssBulkInvoice) {
            rowData.ExtraSelect = isChecked;
            return;
        }
        const existingPartyId = tableList.find(
            row => selectedOrderIdsRef.current.has(row.id)
        )?.CustomerID;

        if (isChecked) {
            // 🔥 Party switched → clear old party IDs
            if (existingPartyId && existingPartyId !== partyId) {
                selectedOrderIdsRef.current.clear();
            }

            tableList.forEach(row => {
                if (
                    row.CustomerID === partyId &&
                    !row.forceExtraSelectDissabled
                ) {
                    selectedOrderIdsRef.current.add(row.id);
                }
            });
        }
        else {
            selectedOrderIdsRef.current.delete(rowData.id);
        }
        const updatedTableList = tableList.map(row => ({
            ...row,
            ExtraSelect: selectedOrderIdsRef.current.has(row.id),
        }));

        dispatch(_act.getOrderListPageSuccess(updatedTableList));
    };

    const hideOrderConfirm = useMemo(
        () => _cfunc.shouldHideOrderConfirm(subPageMode, url.ORDER_LIST_4),
        [subPageMode, commonPartyDropSelect.value]
    );

    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={reducers.goBtnloading || !pageField} />

            <div className="page-content">

                {
                    (pageField) ?
                        <CommonPurchaseList
                            action={tableAction}
                            reducers={reducers}
                            showBreadcrumb={false}
                            masterPath={otherState.masterPath}
                            newBtnPath={otherState.newBtnPath}
                            makeBtnShow={otherState.makeBtnShow}
                            pageMode={pageMode}
                            minPrintBtn_Func={minPrintBtn_Func}
                            HeaderContent={HeaderContent}
                            viewApprovalBtnFunc={viewApprovalBtnFunc}
                            goButnFunc={goButtonHandler}
                            downBtnFunc={downBtnFunc}
                            editBodyfunc={editBodyfunc}
                            thermalprintBtnFunc={thermalprintBtnFunc}
                            makeBtnFunc={makeBtnFunc}
                            hideBtnFunc={hideBtnFunc}
                            ButtonMsgLable={subPageMode === url.IB_ORDER_PO_LIST ? "Demand" : subPageMode === url.IB_ORDER_SO_LIST ? "" : "Order"}
                            deleteName={"FullOrderNumber"}
                            makeBtnName={otherState.makeBtnName}
                            MasterModal={Order}
                            ViewModal={OrderView}
                            oderAprovalBtnFunc={oderAprovalBtnFunc}
                            sendFunc={sendFunc}
                            ManuallyCloseFunc={ManuallyCloseFunc}
                            makeChallan={makeChallan}
                            extraSelect={extraSelect}
                            hideChallanFlags={subPageMode === url.ORDER_LIST_2}
                            selectCheckParams={{
                                isExtraSelectShow: (subPageMode === url.ORDER_LIST_4 && LoginDetails?.PartyType === "Division") || (subPageMode === url.ORDER_LIST_4 && (isSweetAndSnacksCompany)) ? true : false,
                                ExtraSelectBtnHandler: ((subPageMode === url.ORDER_LIST_4) && (isSweetAndSnacksCompany)) ? BulkInvoice_Handler : ExtraSelectBtnHandler,
                                ExtraSelectLabel: (subPageMode === url.ORDER_LIST_4 && LoginDetails?.PartyType === "Division") ? "Print All" : "Bulk Invoice",
                                headerselecthandler: headerselecthandler,
                                selecthandler: selecthandler,
                                ExtraBtnLoading: printAllBtnLoading || makeBulkInvoiceLoading,
                                forceHideSelect: hideOrderConfirm,   // 👈 new — hides checkbox column + save button fully
                                selectSaveBtnHandler: (subPageMode === url.ORDER_APPROVAL) ? AccountsApprove_Handler
                                    : (subPageMode === url.ORDER_LIST_4) ? OrderConfirm_Handler
                                        : BulkInvoice_Handler,
                                selectSaveBtnLabel: (subPageMode === url.ORDER_APPROVAL) ? "Accounts Approve"
                                    : (subPageMode === url.ORDER_LIST_4) ? "Confirm"
                                        : "Bulk Invoice",
                                selectHeaderLabel: (subPageMode === url.ORDER_APPROVAL) ? "Accounts Approve"
                                    : (subPageMode === url.ORDER_LIST_4) ? "Confirm"
                                        : "Bulk Invoice",
                                selectSaveBtnLoading: (subPageMode === url.APP_ORDER_LIST && makeBulkInvoiceLoading)
                                    || (subPageMode === url.ORDER_APPROVAL && accountsApproveLoading),
                            }}
                            totalAmountShow={true}
                        />
                        : null
                }

            </div>

            <OrderView_Modal />{/** order view component */}

        </React.Fragment>
    )
}

export default OrderList;
